import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
import Catalogs from '../catalogs'
import app from '../../main' // import the instance
import axios from 'axios' // remove comment if yu needed
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  contpaq_id: payload.contpaq_id,
  code: payload.code,
  name: payload.name,
  description: payload.description,
  quantity: payload.quantity,
  alternative_code: payload.alternative_code,
  units_measurement: payload.units_measurement,
  weight: payload.weight,
  packing: payload.packing,
  location_1_id: payload.location_1_id,
  location_2_id: payload.location_2_id
})
var crud = new Crud('Products', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  products: [],
  syncro: false,
  catalog: {},
  isModalLocationVisible: false,
  canSync: false
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations,
  SET_RECORDS (state, payload) {
    state.products = payload.data

    state.pagination = {
      currentPage: payload.meta.current_page,
      perPage: payload.meta.per_page,
      totalUsers: payload.meta.total,
      totalPages: payload.meta.last_page
    }
  },
  SET_SYNCRO (state, payload) {
    state.syncro = payload
  },
  SET_MODAL_LOCATION_VISIBLE (state, payload) {
    state.isModalLocationVisible = payload
  },
  SET_CAN_SYNC (state, payload) {
    state.canSync = payload
  }
}

const actions = {
  ...crud.actions,
  ...catalogs.actions,
  async checkSyncro ({ commit }) {
    app.$Progress.start()
    try {
      const response = await axios.get(`/contpaq/syncro`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        const data = typeof response.data === 'object' ? null : response.data

        const actions = {
          false: () => {
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.syncro' }, { root: true })
          },
          true: () => {
            commit('SET_SYNCRO', data)
          },
          null: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.contpaq', text: 'errors.syncro_request_error' }, { root: true })
          },
          default: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.connection_error' }, { root: true })
          }
        };

        (actions[data] || actions.default)()
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async syncProducts ({ commit }) {
    app.$Progress.start()
    try {
      const response = await axios.get(`contpaq/products`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async syncRecord ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`contpaq/products/${payload.code}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setOrdersModalVisible ({ commit }, payload) {
    commit('SET_ORDERS_MODAL_VISIBLE', payload)
  },
  setModalLocationVisible ({ commit }, payload) {
    commit('SET_MODAL_LOCATION_VISIBLE', payload)
  },
  exportWithoutLocation ({ commit }) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/products/without-location?format=csv`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async getQuantityJobs ({ commit }) {
    try {
      const response = await axios.get(`contpaq/jobs/quantity`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        return response.data
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  setCanSync ({ commit }, payload) {
    commit('SET_CAN_SYNC', payload)
  }
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  products: state => state.products,
  locations: state => state.locations,
  syncro: state => state.syncro,
  isModalLocationVisible: state => state.isModalLocationVisible,
  catalog: state => state.catalog,
  canSync: state => state.canSync
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
